module.exports = __webpack_public_path__ + "img/AT0000059534139.f8c55c6b.png";